define([
	"dojo/_base/declare",
	"csi",
	"csi/config",
	"csi/state/rootStore",
	"csi/xml",
	"./_ProductFormMixin"
], function(declare,csi,config,{ routerStore },xml,_ProductFormMixin) {

	return declare(_ProductFormMixin, {
		onChangeCreateStyles: function(/*View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update button states based on change
			this.viewParent.set("disabled", false);
		},

		onChangeSubtype: function(/*View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update options fields based on subtype
			var bType = (xml.isValidURL(value) && config.getSubtypeSetting(value, "ChildrenSubtypes").length > 0);
			this.setFieldValue("MerchOptionQuantity", 0);
			this.setFieldDisabled("MerchOptionName", !bType);
			this.setFieldDisabled("MerchOptionQuantity", !bType);
		},

		onChangeOptionQty: function(/*View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update option type field based on qty
			const bCondition = (value > 0);
			const productSubtypeUrl = this.getFieldValue("Subtype");
			const optionSubtypeUrls = config.getSubtypeSetting(productSubtypeUrl, "ChildrenSubtypes");
			this.setFieldRequired("MerchOptionType", bCondition);
			this.setFieldDisabled("MerchOptionType", !bCondition);
			if (bCondition && optionSubtypeUrls.length == 1) {
				this.setFieldValue("MerchOptionType", optionSubtypeUrls[0]);
			} else {
				this.setFieldValue("MerchOptionType", csi.EMPTY_URL);
			}
		},

		_resolveView: function() {
			// summary: initialize name field to MerchCollection name
			this.inherited(arguments);
			this.setFieldDisabled("MerchOptionName", true);
			this.setFieldDisabled("MerchOptionQuantity", true);
			this.setFieldDisabled("MerchOptionType", true);
			const mc = routerStore.getBreadcrumbNode("MerchCollection");
			if (mc) {
				this.addDefaultValue(xml.ATTR_NAME, mc.$Name);
			}

		}
	});
});